<template lang="pug">
  .statistics-last-order-expansions
    GenericTable
      tr(slot="thead")
        th Order Id
        th Sequence
        th Owner
        th Type
        th Size
        th Start Index
        th End Index
        th Created
        th Name
      tr(v-for="d in data")
        td {{d.orderId}}
        td {{d.sequence}}
        td
          span(v-if="d.owner && d.owner.group") {{d.owner.group.name}}
        td {{d.codePattern | type}}-{{d.codePattern}} ({{d.codeLength}})
        td {{d.size}}
        td {{d.startIndex}}
        td {{d.endIndex}}
        td {{d.created | date}}
        td {{d.name}}
</template>

<script>
import GenericTable from '@/components/common/GenericTable'
import { numberFilter, dateFilter, expansionType } from '@/filters/filters'

export default {
  props: {
    data: {
      type: Array
    }
  },
  components: {
    GenericTable
  },
  filters: {
    number: numberFilter,
    date: dateFilter,
    type: expansionType
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/statistic/LastOrderExpansions.vue